var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCommands = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.3,
    height: 19.3,
    viewBox: "0 0 19.3 19.3",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(-639.902 -701.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "command",
    d: "M22.484,30.032a3.484,3.484,0,1,0,3.484,3.484V32.355h4.065v1.161a3.484,3.484,0,1,0,3.484-3.484H32.355V25.968h1.161a3.484,3.484,0,1,0-3.484-3.484v1.161H25.968V22.484a3.484,3.484,0,1,0-3.484,3.484h1.161v4.065Zm1.161,3.484a1.161,1.161,0,1,1-1.161-1.161h1.161Zm9.871-1.161a1.161,1.161,0,1,1-1.161,1.161V32.355Zm-1.161-9.871a1.161,1.161,0,1,1,1.161,1.161H32.355Zm-9.871,1.161a1.161,1.161,0,1,1,1.161-1.161v1.161Zm3.484,2.323h4.065v4.065H25.968Z",
    transform: "translate(621.552 683.553)",
    fill: "#cf2c73",
    stroke: "#fff",
    strokeWidth: 1.3
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCommands);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/commands.a445197cc69d9c39265033f065084f9f.svg";